import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=4b63f42e&scoped=true&"
import script from "./TransitionExpand.vue?vue&type=script&lang=js&"
export * from "./TransitionExpand.vue?vue&type=script&lang=js&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=4b63f42e&prod&lang=css&"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&id=4b63f42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63f42e",
  null
  
)

export default component.exports